import { StyleSheet } from 'react-native';

import { isTablet } from 'utils/responsiveness';

const styles = StyleSheet.create({
    rootFullscreen: {
        alignSelf: 'center',
        alignItems: 'center',
        width: 480,
    },
    rootEmbedded: {
        flex: 1,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        width: isTablet ? 476 : 228,
    },
    container: {
        width: isTablet ? 228 : '100%',
    },
    titleContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        marginRight: 4,
        marginTop: -4,
    },
    description: {
        marginTop: 8,
        textAlign: 'center',
    },
    transparentText: {
        opacity: isTablet ? 0.7 : 1,
    },
});

export default styles;
